
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/canais-de-atendimento",
      function () {
        return require("private-next-pages/canais-de-atendimento.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/canais-de-atendimento"])
      });
    }
  